// tour.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as TourActions from './tour.actions';

export interface TourState {
  active: boolean;
  completed: boolean;
  currentRoute: string;
  currentStepIndex: number;
  lastUpdateTime: number;
}

export const initialState: TourState = {
  active: false,
  completed: false,
  currentRoute: '',
  currentStepIndex: 0,
  lastUpdateTime: 0
};

export const tourReducer = createReducer(
  initialState,
  on(TourActions.startTour, (state, { route }) => ({
    ...state,
    active: true,
    currentRoute: route || state.currentRoute,
    currentStepIndex: 0,
    lastUpdateTime: Date.now()
  })),
  on(TourActions.completeTour, (state) => ({
    ...state,
    active: false,
    completed: true,
    lastUpdateTime: Date.now()
  })),
  on(TourActions.cancelTour, (state) => ({
    ...state,
    active: false,
    lastUpdateTime: Date.now()
  })),
  on(TourActions.resetTourStatus, (state) => ({
    ...state,
    completed: false,
    lastUpdateTime: Date.now()
  })),
  on(TourActions.setTourActive, (state, { active }) => ({
    ...state,
    active,
    lastUpdateTime: Date.now()
  })),
  on(TourActions.advanceStep, (state, { stepIndex }) => ({
    ...state,
    currentStepIndex: stepIndex,
    lastUpdateTime: Date.now()
  })),
  on(TourActions.setCurrentRoute, (state, { route }) => ({
    ...state,
    currentRoute: route,
    lastUpdateTime: Date.now()
  })),
  on(TourActions.resumeTour, (state, { route, stepIndex }) => ({
    ...state,
    active: true,
    currentRoute: route,
    currentStepIndex: stepIndex,
    lastUpdateTime: Date.now()
  }))
);
